var _defs, _metadata, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoPriceMarkerBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    id: "svg24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs28"
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata16"
  }, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), /*#__PURE__*/React.createElement("g", {
    id: "g22"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500.3,193.3c-95.8,0-173.8,77.5-173.8,172.8c0,95.4,78,172.8,173.8,172.8c95.8,0,173.7-77.5,173.7-172.8C674,270.8,596.1,193.3,500.3,193.3L500.3,193.3z M500.3,481.1c-63.7,0-115.6-51.5-115.6-115c0-63.3,51.9-115,115.6-115c63.7,0,115.5,51.6,115.5,115C615.9,429.5,564,481.1,500.3,481.1L500.3,481.1z",
    id: "path18"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M500.1,990c-15.3,0-32.2-6.8-51.6-21c-15.2-11.1-32.2-26.8-50.5-46.7c-36-39.2-75.3-93-110.8-151.5c-39.4-65.1-72.7-133.5-96.3-198c-27.8-76.2-42-145.8-42-206.6c0-95.1,36.5-184.6,102.8-251.8C318.1,47,406.3,10,500,10c93.7,0,181.9,37,248.2,104.3C814.5,181.6,851,271,851,366.1c0,60.8-14.2,130.4-42.2,206.7c-23.4,64.4-56.8,132.8-96.4,197.9c-35.4,58.3-74.8,112.2-110.8,151.4c-18.2,19.8-35.1,35.6-50.3,46.7C532,983.2,515.3,990,500.1,990L500.1,990z M500.1,69.2c-78.2,0-151.7,30.9-206.9,87c-55.3,56.1-85.7,130.7-85.7,210c0,100.1,46.1,234.4,126.4,368.7c32.8,54.8,69.2,105.3,102.6,142.6c36.6,40.7,57.7,52.2,63.6,53.5c5.8-1.4,27-13.1,63.6-54.1c33.4-37.4,69.9-88.1,102.6-142.7c80.6-134.2,126.7-268.3,126.7-368c0-79.3-30.4-153.9-85.7-210C651.8,100,578.3,69.2,500.1,69.2L500.1,69.2z",
    id: "path20",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.707107
    },
    d: "M 423.47668,861.78639 C 383.9947,814.39164 345.12466,756.40032 310.79391,693.67175 301.13507,676.02329 280.599,634.91687 272.99525,618.01132 228.7213,519.57636 206.26828,429.759 208.12203,358.50314 c 0.62156,-23.89183 3.03745,-42.0611 8.60295,-64.70027 16.36765,-66.57993 55.12091,-125.07979 110.34326,-166.56833 97.73655,-73.429437 231.77316,-77.056839 333.53311,-9.02632 52.40312,35.03353 92.71139,86.35701 114.02816,145.18905 11.63088,32.10002 18.02981,68.3564 18.03547,102.189 0.0112,66.66864 -20.87345,150.37145 -59.65954,239.10774 -39.27062,89.84483 -96.33957,183.79687 -154.4329,254.24132 l -8.29092,10.05365 -70.38358,0.0226 -70.38358,0.0226 z m 99.34937,-324.08996 c 54.24069,-6.72649 103.63349,-40.29318 129.97619,-88.33007 23.79906,-43.39848 27.99025,-92.91016 11.85524,-140.0493 -7.87156,-22.99709 -21.3962,-44.77395 -39.22153,-63.153 -33.34419,-34.37996 -77.50422,-53.12391 -125.1579,-53.12391 -45.61597,0 -88.44753,17.36816 -121.17838,49.13774 -28.3652,27.53214 -45.97588,62.14047 -51.45684,101.12245 -1.45084,10.31874 -1.62311,32.88516 -0.32928,43.13351 4.89642,38.78433 21.67233,73.40135 48.86632,100.83547 38.83213,39.17506 91.45723,57.27121 146.64618,50.42711 z",
    id: "path926"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.707107
    },
    d: "m 493.71728,927.72717 c -13.98075,-7.6211 -35.66958,-26.85255 -56.62315,-50.20766 l -7.29557,-8.13173 35.06297,-0.18337 c 19.28463,-0.10086 50.79283,-0.10086 70.01822,0 l 34.95527,0.18337 -8.26082,9.19239 c -16.11308,17.93016 -33.70512,34.41491 -46.52304,43.59474 -5.76105,4.1259 -13.5052,8.38513 -15.21414,8.36766 -0.53526,-0.005 -3.28914,-1.2724 -6.11974,-2.8154 z",
    id: "path928"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPriceMarkerBlack);
export default __webpack_public_path__ + "static/media/no_price_marker_black.2989b9a9f667223539f7de7f66505382.svg";
export { ForwardRef as ReactComponent };